import AnimateHeight from 'react-animate-height';
import styled from 'styled-components';

export const AccordionWrapper = styled.div`
  display: block;
`;

export const AccordionItem = styled.div`
  display: block;
`;

export const AccordionTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 24px;
  cursor: pointer;

  h4 {
    margin: 0;
  }

  .icon {
    color: #848fa3;
  }

  &.active {
    .icon {
      transform: rotateZ(180deg);
    }
  }
`;

export const AccordionContent = styled(AnimateHeight)`
  > div {
    padding-bottom: 60px;
    & > ul {
      padding-left: 0;

      & > li:before {
        display: none;
      }
    }
  }
`;
